<template>
    <div class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20">
        <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
            <div class="rlms-fs-lg rlms-fw-600">Learners</div>
            <button class="rlms-btn rlms-btn-primary vue-add-learner-btn" @click="showAddLearnerModal = true" v-if="organization?.is_owner || organization?.is_administrator">Add New
                Learner</button>
        </div>

        <div id="vue-learner-list-container">
            <div class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20">
                <div class="rlms-table-filters">
                    <div class="scrollable-container">
                        <ul class="scrollable-content">
                            <li class="filter-tab" :class="{ 'active-filter': filter.type === 'all' }"><a
                                    href="javascript:void(0)" @click="fetchLearners('all')">All Learners</a></li>
                            <li class="filter-tab" :class="{ 'active-filter': filter.type === 'active' }"><a
                                    href="javascript:void(0)" @click="fetchLearners('active')">Active Learners</a></li>
                            <li class="filter-tab" :class="{ 'active-filter': filter.type === 'inactive' }"><a
                                    href="javascript:void(0)" @click="fetchLearners('inactive')">Inactive Learners</a>
                            </li>
                        </ul>
                    </div>
                    <div class="rlms-tf-actions">
                        <div class="input-icon-group input-icon-right">
                            <input type="search" placeholder="Search..." v-model="filter.search"
                                @input="handleSearch" />
                            <img class="rlms-input-icon" :src="searchIcon">
                        </div>
                        <svg v-if="selectedLearners.length > 0 && (organization?.is_owner || organization?.is_administrator)" class="rlms-popup-btn del-btn" @click="deleteSelected"
                            width="50" height="46" viewBox="0 0 50 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="50" height="46" rx="12" fill="#FFE6DD" />
                            <path
                                d="M36.25 15.4756C32.0875 15.0631 27.9 14.8506 23.725 14.8506C21.25 14.8506 18.775 14.9756 16.3 15.2256L13.75 15.4756"
                                stroke="#FF5664" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M20.625 14.2125L20.9 12.575C21.1 11.3875 21.25 10.5 23.3625 10.5H26.6375C28.75 10.5 28.9125 11.4375 29.1 12.5875L29.375 14.2125"
                                stroke="#FF5664" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M33.5625 19.4258L32.75 32.0133C32.6125 33.9758 32.5 35.5008 29.0125 35.5008H20.9875C17.5 35.5008 17.3875 33.9758 17.25 32.0133L16.4375 19.4258"
                                stroke="#FF5664" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M22.9141 28.625H27.0766" stroke="#FF5664" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M21.875 23.625H28.125" stroke="#FF5664" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>

                <!-- Data table -->
                <div class="rlms-table">
                    <div class="rlms-table-inner">
                        <table>
                            <thead>
                                <tr>
                                    <th>Learner</th>
                                    <th>
                                        <div class="rlms-flex rlms-items-center rlms-gap-2 rlms-cursor-pointer">Code
                                        </div>
                                    </th>
                                    <th>
                                        <div class="rlms-flex rlms-items-center rlms-gap-2 rlms-cursor-pointer">Created
                                            Date</div>
                                    </th>
                                    <th>
                                        <div class="rlms-flex rlms-items-center rlms-gap-2 rlms-cursor-pointer">Subscription
                                        </div>
                                    </th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="learners.length > 0">
                                    <tr v-for="(learner, i) in learners" :key="i">
                                        <td>
                                            <label
                                                class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-fc rlms-us-none">
                                                <input type="checkbox" :value="learner.id" v-model="selectedLearners"
                                                    class="rlms-checkbox" v-if="(organization?.is_owner || organization?.is_administrator)">
                                                <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc"><img
                                                        :src="profileIcon">
                                                    <p class="rlms-fw-500">{{ learner.firstname }} {{ learner.lastname
                                                    }}</p>
                                                </div>
                                            </label>
                                        </td>
                                        <td>{{ learner.information_code }}</td>
                                        <td>
                                            <p class="rlms-text-extra-3">{{ formatDate(learner.created_at) }}</p>
                                        </td>
                                        <td>
                                            <div
                                                :class="`rlms-bg-${learner.subscription_status === true ? 'success' : learner.subscription_status === false ? 'danger' : 'extra'}-100 rlms-text-${learner.subscription_status === true ? 'success' : learner.subscription_status === false ? 'danger' : 'extra'}-600 rlms-py-1 rlms-px-4 rlms-w-fc rlms-br-16 rlms-fw-500`">
                                                {{ learner.subscription_status === true ? 'Active' : learner.subscription_status === false ? 'Expired' : 'None' }}
                                            </div>
                                        </td>
                                        <td>
                                            <RouterLink :to="`/organizations/${organizationId}/learners/${learner.id}`"
                                                class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer">
                                                <img :src="eyeIcon">
                                                <p class="rlms-text-primary-500">View</p>
                                            </RouterLink>
                                        </td>
                                    </tr>
                                </template>
                                <tr v-else>
                                    <td colspan="5">
                                        <div class="rlms-flex rlms-flex-col rlms-gap-30 rlms-text-center rlms-p-3">
                                            <img :src="noDataImage" class="rlms-mx-auto"
                                                style="width: clamp(150px, -1533rem + 3200vw, 150px);">
                                            <p class="rlms-text-center">No record found.</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
        <paginate v-model="page" :page-count="totalPages" :margin-pages="2" :prev-text="'<'" :next-text="'>'"
            :container-class="'pagination'" :page-class="'page-item'" :active-class="'active-page'"
            v-if="totalItems > 0" />
    </div>

    <AddEditLearnerModal v-if="showAddLearnerModal" @close="showAddLearnerModal = false;" @saved="init()"
        :organizationId="organizationId" />
</template>
<script setup>
import { useRoute, RouterLink } from 'vue-router'
import { onMounted, ref, watch } from 'vue'
import axios from "@/services/axios";
import { formatDate } from '@/utils/format-helpers';
import { debounce } from '@/utils/debounce';
import paginate from 'vuejs-paginate-next';
import AddEditLearnerModal from '@/components/AddEditLearnerModal.vue';
import confirmationIcon from '@/assets/images/confirmation.png';
import { handleError } from '@/utils/handleError';
import { useLoaderStore } from '@/stores/loader';
import { showConfirmDialog, showDialog, showToast } from '@/utils/swal';
import searchIcon from '@/assets/images/search.svg'
import profileIcon from '@/assets/images/profile.svg'
import eyeIcon from '@/assets/images/eye.svg'
import noDataImage from '@/assets/images/no-data-img.png'

const route = useRoute();
const loader = useLoaderStore();

const page = ref(1);
const totalPages = ref(1);
const totalItems = ref(0);
const organizationId = Number(route.params.organization ?? 0);
const organization = ref(null);
const learners = ref([]);
const selectedLearners = ref([]);
const showAddLearnerModal = ref(false);

const filter = ref({
    type: 'all',
    search: ''
});

onMounted(async () => {
    init();
});

const init = () => {
    selectedLearners.value = [];
    filter.value.type = 'all';
    filter.value.search = '';
    page.value = 1;

    showAddLearnerModal.value = false;
    fetchLearners();
}

const fetchLearners = async (type = filter.value.type, search = filter.value.search) => {
    try {
        loader.show();

        const { data } = await axios.get(`/organizations/${organizationId}/learners`, {
            params: {
                type,
                search,
                page: page.value,
                per_page: 10
            }
        });

        organization.value = data.data.organization;
        learners.value = data.data.learners.data;

        // Optional: store pagination meta if needed
        totalPages.value = data.data.learners.last_page;
        totalItems.value = data.data.learners.total;

        filter.value.type = type;
        filter.value.search = search;
    } catch (error) {
        handleError(error)
    } finally {
        loader.hide();
    }
};


watch(page, () => {
    fetchLearners();
});

const handleSearch = debounce(function () {
    page.value = 1;
    fetchLearners(filter.value.type, filter.value.search);
}, 400);

const deleteSelected = async () => {
    if (!selectedLearners.value.length) {
        showDialog({
            icon: 'warning',
            title: 'No Selection',
            html: 'Please select at least one learner to delete.',
        });

        return;
    }

    const result = await showConfirmDialog({
        title: 'Are you sure?',
        html: '<p id="text-message">Are you sure you want to delete the selected learner?</p><span class="rlms-text-danger-500" id="delete-confirm"> This action will permanently remove and cannot be undone. </span>',
        confirmButtonText: 'Yes, delete them!',
        imageUrl: confirmationIcon
    });

    if (result.isConfirmed) {
        try {
            loader.show();

            await axios.delete(`/organizations/${organizationId}/learners/1`, {
                data: {
                    selected_learner: selectedLearners.value
                }
            });

            showToast({
                icon: 'success',
                title: 'Deleted! ',
                text: 'The selected learners have been deleted successfully!',
            });

            init();
        } catch (error) {
            handleError(error);
        } finally {
            loader.hide();
        }
    }
};
</script>